import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * PlayIcon - A play icon (triangle pointing right)
 */
export const PlayIcon = ({ size = 16, color = "#374151", className = "", ...props }) => {
    return (_jsx(Icon, { size: size, viewBox: "0 0 16 16", className: className, ...props, children: _jsx("path", { d: "M4 2.5V13.5C4 13.7652 4.15803 14.0054 4.40212 14.1096C4.64621 14.2138 4.92855 14.1627 5.12127 13.9812L12.6213 7.48115C12.7517 7.35809 12.8267 7.18299 12.8267 7C12.8267 6.81701 12.7517 6.64191 12.6213 6.51885L5.12127 0.018848C4.92855 -0.162658 4.64621 -0.213774 4.40212 -0.109589C4.15803 -0.00540495 4 0.234784 4 0.5V2.5Z", fill: color }) }));
};
